import * as $ from 'jquery';
import * as ko from 'knockout';

export interface PopoverOptions {
    Element: HTMLElement;
    Container: any; //HTMLElement & JQuery<HTMLElement>
    Viewport: any; //HTMLElement & JQuery<HTMLElement>
    Placement: string; //'left'
    Trigger: string; //'manual'
    CustomTemplateClass?: string;
}

export interface FlowFolderPopoverOptions {
    EntityId: number;
    RecordId: number;
    PopoverOptions: PopoverOptions;
    IsCardScreen?: boolean;
}

export class FlowFolderPopover {
    private static instance;
    private static allowInstantiation: boolean;

    constructor(options?: FlowFolderPopoverOptions) {
        this.Init(options);
    }

    static get Instance(): FlowFolderPopover {
        if (FlowFolderPopover.instance == null) {
            FlowFolderPopover.allowInstantiation = true;
            FlowFolderPopover.instance = new FlowFolderPopover();
            FlowFolderPopover.allowInstantiation = false;
        }

        return FlowFolderPopover.instance;
    }

    Init(options: FlowFolderPopoverOptions) {
        if (options) {
            this.Destroy(options.PopoverOptions.Element);
            this.Popover(options);
            this.Show(options.PopoverOptions.Element);
        }
    }

    GridRowInit(
        options: FlowFolderPopoverOptions,
        isGroupActive: boolean,
        isWrapperOverflowVisible: boolean
    ): void {
        this.Destroy(options.PopoverOptions.Element);
        if (isGroupActive) {
            this.Popover(options);
            this.Show(options.PopoverOptions.Element, isWrapperOverflowVisible);
        }
    }

    Popover(options: FlowFolderPopoverOptions): void {
        const $el: any = $(options.PopoverOptions.Element);
        $el.popover({
            content: '<i class="fa fa-ellipsis-v" /><i class="fa fa-ellipsis-v" />',
            template: `
                <div class="popover ${options.PopoverOptions.CustomTemplateClass}">
                    <div class="popover-content" />
                </div>
            `,
            html: true,
            placement: options.PopoverOptions.Placement,
            trigger: options.PopoverOptions.Trigger,
            animation: false,
            container: options.PopoverOptions.Container,
            viewport: options.PopoverOptions.Viewport,
        });

        if (options.IsCardScreen) {
            $el.on('shown.bs.popover', (evt) => {
                const $grip = $(`#${$el.attr('aria-describedby')}`);
                $grip.css({ top: evt.currentTarget.offsetTop });
            });
        }

        $el.on('inserted.bs.popover', () => {
            const $grip = $(`#${$el.attr('aria-describedby')}`);

            $grip.data('EntityId', options.EntityId);
            $grip.data('RecordId', options.RecordId);

            $grip.draggable({
                helper: () => $('<div />').append($grip.clone().removeAttr('id')),
                classes: { 'ui-draggable-dragging': 'flow-folder-dragging-helper' },
                appendTo: 'body',
                scrollSensitivity: 75,
                zIndex: 100000,
            });
        });
    }

    Show(element: HTMLElement, overflowVisible: boolean = true): void {
        const $el: any = $(element);
        if ($el.data('bs.popover')) {
            if (overflowVisible) {
                $el.popover('show');
            }
        }
    }

    Destroy(element: HTMLElement): void {
        const $el: any = $(element);
        if ($el.data('bs.popover')) {
            $el.popover('destroy');
        }
    }
}
